<template>
  <svg
    width="20"
    :class="{ 'rotate-svg': rotate }"
    height="26"
    viewBox="0 0 20 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3072 11.2838C19.421 12.0832 19.421 13.9169 18.3072 14.7162L3.62907 25.2501C2.42824 26.1119 0.856864 25.1391 0.856864 23.5339L0.856865 2.46612C0.856865 0.860927 2.42824 -0.11187 3.62907 0.749917L18.3072 11.2838Z"
      fill="#969696"
    />
  </svg>
</template>
<script>
export default {
  name: 'CarouselArrow',
  props: ['rotate']
}
</script>
<style lang="scss" scoped>
.rotate-svg {
  transform: rotate(180deg) translate(0, 50%);
}
</style>
